/**
 * 졸업앨범 목록 데이터
 */
const AlbumData = [
    {
        "book_id": 10401,
        "book_title": "(監理敎會神學校) 卒業紀念 第18回",
        "book_title_ko": "(감리교회신학교) 졸업기념 제18회",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會神學校",
        "publisher_ko": "감리교회신학교",
        "library": "",
        "school_id": 52941,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10401,
        "book_title": "(監理敎會神學校) 卒業紀念 第18回",
        "book_title_ko": "(감리교회신학교) 졸업기념 제18회",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會神學校",
        "publisher_ko": "감리교회신학교",
        "library": "",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10402,
        "book_title": "(京城法政專門學校) 卒業紀念帳 第1回",
        "book_title_ko": "(경성법정전문학교) 졸업기념장 제1회",
        "publish_date": "1929.03.00",
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城法政專門學校",
        "publisher_ko": "경성법정전문학교",
        "library": "",
        "school_id": 45139,
        "primaryname": "京城法政專門學校",
        "primaryname_ko": "경성법정전문학교"
    },
    {
        "book_id": 10402,
        "book_title": "(京城法政專門學校) 卒業紀念帳 第1回",
        "book_title_ko": "(경성법정전문학교) 졸업기념장 제1회",
        "publish_date": "1929.03.00",
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城法政專門學校",
        "publisher_ko": "경성법정전문학교",
        "library": "",
        "school_id": 52772,
        "primaryname": "京城法政專門學校",
        "primaryname_ko": "경성법정전문학교"
    },
    {
        "book_id": 10403,
        "book_title": "(京城商工實務學校) 卒業紀念 電氣科 第3回",
        "book_title_ko": "(경성상공실무학교) 졸업기념 전기과 제3회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城商工實務學校 電氣科",
        "publisher_ko": "경성상공실무학교 전기과",
        "library": "△",
        "school_id": 52942,
        "primaryname": "京城商工實務學校 電氣科",
        "primaryname_ko": "경성상공실무학교 전기과"
    },
    {
        "book_id": 10403,
        "book_title": "(京城商工實務學校) 卒業紀念 電氣科 第3回",
        "book_title_ko": "(경성상공실무학교) 졸업기념 전기과 제3회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城商工實務學校 電氣科",
        "publisher_ko": "경성상공실무학교 전기과",
        "library": "△",
        "school_id": 52773,
        "primaryname": "京城商工實務學校",
        "primaryname_ko": "경성상공실무학교"
    },
    {
        "book_id": 10404,
        "book_title": "(京城商科學校) 卒業紀念 ",
        "book_title_ko": "(경성상과학교) 졸업기념 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城商科學校",
        "publisher_ko": "경성상과학교",
        "library": "△",
        "school_id": 27607,
        "primaryname": "京城商科學校",
        "primaryname_ko": "경성상과학교"
    },
    {
        "book_id": 10404,
        "book_title": "(京城商科學校) 卒業紀念 ",
        "book_title_ko": "(경성상과학교) 졸업기념 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城商科學校",
        "publisher_ko": "경성상과학교",
        "library": "△",
        "school_id": 52774,
        "primaryname": "京城商科學校",
        "primaryname_ko": "경성상과학교"
    },
    {
        "book_id": 10405,
        "book_title": "(京城英彰學校) 卒業紀念 第21回",
        "book_title_ko": "(경성영창학교) 졸업기념 제21회",
        "publish_date": "1942.02.00",
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 0,
        "publisher": "中央基督敎靑年會學校",
        "publisher_ko": "중앙기독교청년회학교",
        "library": "△",
        "school_id": 52943,
        "primaryname": "中央基督敎靑年會學校",
        "primaryname_ko": "중앙기독교청년회학교"
    },
    {
        "book_id": 10405,
        "book_title": "(京城英彰學校) 卒業紀念 第21回",
        "book_title_ko": "(경성영창학교) 졸업기념 제21회",
        "publish_date": "1942.02.00",
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 0,
        "publisher": "中央基督敎靑年會學校",
        "publisher_ko": "중앙기독교청년회학교",
        "library": "△",
        "school_id": 52775,
        "primaryname": "京城英彰學校",
        "primaryname_ko": "경성영창학교"
    },
    {
        "book_id": 10406,
        "book_title": "(昭和工科學校) 卒業記念 鑛山科",
        "book_title_ko": "(소화공과학교) 졸업기념 광산과",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "△",
        "school_id": 52776,
        "primaryname": "昭和工科學校",
        "primaryname_ko": "소화공과학교"
    },
    {
        "book_id": 10407,
        "book_title": "(崇實學校) 卒業紀念 寫眞帳 第15回",
        "book_title_ko": "(숭실학교) 졸업기념 사진장 제15회",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "崇實學校",
        "publisher_ko": "숭실학교",
        "library": "△",
        "school_id": 52938,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10407,
        "book_title": "(崇實學校) 卒業紀念 寫眞帳 第15回",
        "book_title_ko": "(숭실학교) 졸업기념 사진장 제15회",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "崇實學校",
        "publisher_ko": "숭실학교",
        "library": "△",
        "school_id": 52763,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10408,
        "book_title": "(中東學校) 卒業生 卒業紀念 第11回",
        "book_title_ko": "(중동학교) 졸업생 졸업기념 제11회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "中東學校",
        "publisher_ko": "중동학교",
        "library": "△",
        "school_id": 27603,
        "primaryname": "中東學校",
        "primaryname_ko": "중동학교"
    },
    {
        "book_id": 10408,
        "book_title": "(中東學校) 卒業生 卒業紀念 第11回",
        "book_title_ko": "(중동학교) 졸업생 졸업기념 제11회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "中東學校",
        "publisher_ko": "중동학교",
        "library": "△",
        "school_id": 52777,
        "primaryname": "中東學校",
        "primaryname_ko": "중동학교"
    },
    {
        "book_id": 10425,
        "book_title": "(京城高等女學校) 卒業紀念 (皇紀)2603",
        "book_title_ko": "(경성고등여학교) 졸업기념 (황기)2603",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城高等女學校",
        "publisher_ko": "경성고등여학교",
        "library": "△",
        "school_id": 52947,
        "primaryname": "京城高等女學校",
        "primaryname_ko": "경성고등여학교"
    },
    {
        "book_id": 10425,
        "book_title": "(京城高等女學校) 卒業紀念 (皇紀)2603",
        "book_title_ko": "(경성고등여학교) 졸업기념 (황기)2603",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城高等女學校",
        "publisher_ko": "경성고등여학교",
        "library": "△",
        "school_id": 52789,
        "primaryname": "京城高等女學校",
        "primaryname_ko": "경성고등여학교"
    },
    {
        "book_id": 10426,
        "book_title": "(光州旭高等女學校) 卒業記念 第9回",
        "book_title_ko": "(광주욱고등여학교) 졸업기념 제9회",
        "publish_date": "1939.03.00",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州旭公立高等女學校",
        "publisher_ko": "광주욱공립고등여학교",
        "library": "△",
        "school_id": 52948,
        "primaryname": "光州旭公立高等女學校",
        "primaryname_ko": "광주욱공립고등여학교"
    },
    {
        "book_id": 10426,
        "book_title": "(光州旭高等女學校) 卒業記念 第9回",
        "book_title_ko": "(광주욱고등여학교) 졸업기념 제9회",
        "publish_date": "1939.03.00",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州旭公立高等女學校",
        "publisher_ko": "광주욱공립고등여학교",
        "library": "△",
        "school_id": 52790,
        "primaryname": "光州旭高等女學校",
        "primaryname_ko": "광주욱고등여학교"
    },
    {
        "book_id": 10427,
        "book_title": "(同德高等女學校) 卒業記念 第25回",
        "book_title_ko": "(동덕고등여학교) 졸업기념 제25회",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德高等女學校",
        "publisher_ko": "동덕고등여학교",
        "library": "△",
        "school_id": 27358,
        "primaryname": "同德高等女學校",
        "primaryname_ko": "동덕고등여학교"
    },
    {
        "book_id": 10427,
        "book_title": "(同德高等女學校) 卒業記念 第25回",
        "book_title_ko": "(동덕고등여학교) 졸업기념 제25회",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德高等女學校",
        "publisher_ko": "동덕고등여학교",
        "library": "△",
        "school_id": 52791,
        "primaryname": "同德高等女學校",
        "primaryname_ko": "동덕여자고등보통학교"
    },
    {
        "book_id": 10428,
        "book_title": "(淑明高等女學校) 卒業記念 第34回",
        "book_title_ko": "(숙명고등여학교) 졸업기념 제34회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "淑明高等女學校",
        "publisher_ko": "숙명고등여학교",
        "library": "△",
        "school_id": 52949,
        "primaryname": "淑明高等女學校",
        "primaryname_ko": "숙명고등여학교"
    },
    {
        "book_id": 10428,
        "book_title": "(淑明高等女學校) 卒業記念 第34回",
        "book_title_ko": "(숙명고등여학교) 졸업기념 제34회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "淑明高等女學校",
        "publisher_ko": "숙명고등여학교",
        "library": "△",
        "school_id": 52792,
        "primaryname": "淑明高等女學校",
        "primaryname_ko": "숙명여자고등여학교"
    },
    {
        "book_id": 10429,
        "book_title": "(順天高等女學敎) 卒業記念 第1回",
        "book_title_ko": "(순천고등여학교) 졸업기념 제1회",
        "publish_date": "1944.00.00",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "順天公立高等女學敎",
        "publisher_ko": "순천공립고등여학교",
        "library": "△",
        "school_id": 52950,
        "primaryname": "順天公立高等女學敎",
        "primaryname_ko": "순천공립고등여학교"
    },
    {
        "book_id": 10429,
        "book_title": "(順天高等女學敎) 卒業記念 第1回",
        "book_title_ko": "(순천고등여학교) 졸업기념 제1회",
        "publish_date": "1944.00.00",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "順天公立高等女學敎",
        "publisher_ko": "순천공립고등여학교",
        "library": "△",
        "school_id": 52793,
        "primaryname": "順天高等女學敎",
        "primaryname_ko": "순천고등여학교"
    },
    {
        "book_id": 10430,
        "book_title": "(龍谷高等女學校) 卒業記念 第11回",
        "book_title_ko": "(용곡고등여학교) 졸업기념 제11회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "龍谷高等女學校",
        "publisher_ko": "용곡고등여학교",
        "library": "△",
        "school_id": 52951,
        "primaryname": "龍谷高等女學校",
        "primaryname_ko": "용곡고등여학교"
    },
    {
        "book_id": 10430,
        "book_title": "(龍谷高等女學校) 卒業記念 第11回",
        "book_title_ko": "(용곡고등여학교) 졸업기념 제11회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "龍谷高等女學校",
        "publisher_ko": "용곡고등여학교",
        "library": "△",
        "school_id": 52794,
        "primaryname": "龍谷高等女學校",
        "primaryname_ko": "용곡고등여학교"
    },
    {
        "book_id": 10431,
        "book_title": "(裡里高等女學校) 卒業記念 第14回",
        "book_title_ko": "(이리고등여학교) 졸업기념 제14회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "裡里公立高等女學校",
        "publisher_ko": "이리공립고등여학교",
        "library": "△",
        "school_id": 52952,
        "primaryname": "裡里公立高等女學校",
        "primaryname_ko": "이리공립고등여학교"
    },
    {
        "book_id": 10431,
        "book_title": "(裡里高等女學校) 卒業記念 第14回",
        "book_title_ko": "(이리고등여학교) 졸업기념 제14회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "裡里公立高等女學校",
        "publisher_ko": "이리공립고등여학교",
        "library": "△",
        "school_id": 52795,
        "primaryname": "裡里高等女學校",
        "primaryname_ko": "이리고등여학교"
    },
    {
        "book_id": 10432,
        "book_title": "(仁川昭和高等女學校) 卒業記念 第1回  (昭和19年度)",
        "book_title_ko": "(인천소화고등여학교) 졸업기념 제1회  (소화19년도)",
        "publish_date": "1944.00.00",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "仁川昭和高等女學校",
        "publisher_ko": "인천소화고등여학교",
        "library": "△",
        "school_id": 52953,
        "primaryname": "仁川昭和高等女學校",
        "primaryname_ko": "인천소화고등여학교"
    },
    {
        "book_id": 10432,
        "book_title": "(仁川昭和高等女學校) 卒業記念 第1回  (昭和19年度)",
        "book_title_ko": "(인천소화고등여학교) 졸업기념 제1회  (소화19년도)",
        "publish_date": "1944.00.00",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "仁川昭和高等女學校",
        "publisher_ko": "인천소화고등여학교",
        "library": "△",
        "school_id": 52796,
        "primaryname": "仁川昭和高等女學校",
        "primaryname_ko": "인천소화고등여학교"
    },
    {
        "book_id": 10433,
        "book_title": "(好壽敦高等女學校) 卒業記念 第18回",
        "book_title_ko": "(호수돈고등여학교) 졸업기념 제18회",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦高等女學校",
        "publisher_ko": "호수돈고등여학교",
        "library": "△",
        "school_id": 52954,
        "primaryname": "好壽敦高等女學校",
        "primaryname_ko": "호수돈고등여학교"
    },
    {
        "book_id": 10433,
        "book_title": "(好壽敦高等女學校) 卒業記念 第18回",
        "book_title_ko": "(호수돈고등여학교) 졸업기념 제18회",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦高等女學校",
        "publisher_ko": "호수돈고등여학교",
        "library": "△",
        "school_id": 52785,
        "primaryname": "好壽敦高等女學校",
        "primaryname_ko": "호수돈고등여학교"
    },
    {
        "book_id": 10434,
        "book_title": "(好壽敦高等女學校) 卒業記念 第19回",
        "book_title_ko": "(호수돈고등여학교) 졸업기념 제19회",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦高等女學校",
        "publisher_ko": "호수돈고등여학교",
        "library": "△",
        "school_id": 52954,
        "primaryname": "好壽敦高等女學校",
        "primaryname_ko": "호수돈고등여학교"
    },
    {
        "book_id": 10434,
        "book_title": "(好壽敦高等女學校) 卒業記念 第19回",
        "book_title_ko": "(호수돈고등여학교) 졸업기념 제19회",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦高等女學校",
        "publisher_ko": "호수돈고등여학교",
        "library": "△",
        "school_id": 52785,
        "primaryname": "好壽敦高等女學校",
        "primaryname_ko": "호수돈고등여학교"
    },
    {
        "book_id": 10553,
        "book_title": "(京城高等普通學校) 卒業生記念帖 第7回",
        "book_title_ko": "(경성고등보통학교) 졸업생기념첩 제7회",
        "publish_date": "1917.03.20",
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 20,
        "publisher": "",
        "publisher_ko": "",
        "library": "△",
        "school_id": 52823,
        "primaryname": "京城高等普通學校",
        "primaryname_ko": "경성고등보통학교"
    },
    {
        "book_id": 10554,
        "book_title": "(京城第一高等普通學校) 卒業記念 第24回 卒業生",
        "book_title_ko": "(경성제일고등보통학교) 졸업기념 제24회 졸업생",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校",
        "publisher_ko": "경성제일고등보통학교",
        "library": "△",
        "school_id": 28175,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교;경기고등학교"
    },
    {
        "book_id": 10554,
        "book_title": "(京城第一高等普通學校) 卒業記念 第24回 卒業生",
        "book_title_ko": "(경성제일고등보통학교) 졸업기념 제24회 졸업생",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校",
        "publisher_ko": "경성제일고등보통학교",
        "library": "△",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10555,
        "book_title": "(公州高等普通學校) 卒業記念寫眞帖 第11回",
        "book_title_ko": "(공주고등보통학교) 졸업기념사진첩 제11회",
        "publish_date": "1937.03.00",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "公州公立高等普通學校",
        "publisher_ko": "공주공립고등보통학교",
        "library": "△",
        "school_id": 52957,
        "primaryname": "公州公立高等普通學校",
        "primaryname_ko": "공주공립고등보통학교"
    },
    {
        "book_id": 10555,
        "book_title": "(公州高等普通學校) 卒業記念寫眞帖 第11回",
        "book_title_ko": "(공주고등보통학교) 졸업기념사진첩 제11회",
        "publish_date": "1937.03.00",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "公州公立高等普通學校",
        "publisher_ko": "공주공립고등보통학교",
        "library": "△",
        "school_id": 52804,
        "primaryname": "公州高等普通學校",
        "primaryname_ko": "공주고등보통학교"
    },
    {
        "book_id": 10556,
        "book_title": "(普成高等普通學校) 卒業記念 第12回",
        "book_title_ko": "(보성고등보통학교) 졸업기념 제12회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "△",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10556,
        "book_title": "(普成高等普通學校) 卒業記念 第12回",
        "book_title_ko": "(보성고등보통학교) 졸업기념 제12회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "△",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10557,
        "book_title": "(普成高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(보성고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1931.03.00",
        "publish_year": 1931,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "△",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10557,
        "book_title": "(普成高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(보성고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1931.03.00",
        "publish_year": 1931,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "△",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10558,
        "book_title": "(中央高等普通學校) (졸업앨범) ",
        "book_title_ko": "(중앙고등보통학교) (졸업앨범) ",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "○",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10559,
        "book_title": "(晋州高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(진주고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "晋州公立高等普通學校",
        "publisher_ko": "진주공립고등보통학교",
        "library": "△",
        "school_id": 52960,
        "primaryname": "晋州公立高等普通學校",
        "primaryname_ko": "진주공립고등보통학교"
    },
    {
        "book_id": 10559,
        "book_title": "(晋州高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(진주고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "晋州公立高等普通學校",
        "publisher_ko": "진주공립고등보통학교",
        "library": "△",
        "school_id": 52822,
        "primaryname": "晋州高等普通學校",
        "primaryname_ko": "진주고등보통학교"
    },
    {
        "book_id": 10560,
        "book_title": "(忠南高等普通學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(충남고등보통학교) 졸업기념사진첩 제2회",
        "publish_date": "1928.03.00",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "忠南公立高等普通學校",
        "publisher_ko": "충남공립고등보통학교",
        "library": "△",
        "school_id": 52961,
        "primaryname": "忠南公立高等普通學校",
        "primaryname_ko": "충남공립고등보통학교"
    },
    {
        "book_id": 10560,
        "book_title": "(忠南高等普通學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(충남고등보통학교) 졸업기념사진첩 제2회",
        "publish_date": "1928.03.00",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "忠南公立高等普通學校",
        "publisher_ko": "충남공립고등보통학교",
        "library": "△",
        "school_id": 52824,
        "primaryname": "忠南高等普通學校",
        "primaryname_ko": "충남고등보통학교"
    },
    {
        "book_id": 10674,
        "book_title": "(京城師範學校) 卒業記念 第17回",
        "book_title_ko": "(경성사범학교) 졸업기념 제17회",
        "publish_date": "1939.03.00",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "△",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10675,
        "book_title": "(全州師範學校) 卒業記念 尋常科 第2回",
        "book_title_ko": "(전주사범학교) 졸업기념 심상과 제2회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "全州師範學校",
        "publisher_ko": "전주사범학교",
        "library": "국립중앙도서관;연세대△",
        "school_id": 4711,
        "primaryname": "全州師範學校",
        "primaryname_ko": "전주사범학교"
    },
    {
        "book_id": 10675,
        "book_title": "(全州師範學校) 卒業記念 尋常科 第2回",
        "book_title_ko": "(전주사범학교) 졸업기념 심상과 제2회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "全州師範學校",
        "publisher_ko": "전주사범학교",
        "library": "국립중앙도서관;연세대△",
        "school_id": 52832,
        "primaryname": "全州師範學校",
        "primaryname_ko": "전주사범학교"
    },
    {
        "book_id": 10676,
        "book_title": "(忠淸南道師範學校) 記念寫眞帖 ",
        "book_title_ko": "(충청남도사범학교) 기념사진첩 ",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "忠淸南道公立師範學校",
        "publisher_ko": "충청남도공립사범학교",
        "library": "△",
        "school_id": 52964,
        "primaryname": "忠淸南道公立師範學校",
        "primaryname_ko": "충청남도공립사범학교"
    },
    {
        "book_id": 10676,
        "book_title": "(忠淸南道師範學校) 記念寫眞帖 ",
        "book_title_ko": "(충청남도사범학교) 기념사진첩 ",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "忠淸南道公立師範學校",
        "publisher_ko": "충청남도공립사범학교",
        "library": "△",
        "school_id": 52834,
        "primaryname": "忠淸南道師範學校",
        "primaryname_ko": "충청남도사범학교"
    },
    {
        "book_id": 10677,
        "book_title": "(平壤師範學校) 卒業記念 ",
        "book_title_ko": "(평양사범학교) 졸업기념 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤師範學校",
        "publisher_ko": "평양사범학교",
        "library": "△",
        "school_id": 3053,
        "primaryname": "平壤師範學校",
        "primaryname_ko": "학교>평양사범학교"
    },
    {
        "book_id": 10677,
        "book_title": "(平壤師範學校) 卒業記念 ",
        "book_title_ko": "(평양사범학교) 졸업기념 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "平壤師範學校",
        "publisher_ko": "평양사범학교",
        "library": "△",
        "school_id": 52833,
        "primaryname": "平壤師範學校",
        "primaryname_ko": "평양사범학교"
    },
    {
        "book_id": 10725,
        "book_title": "(江景商業學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(강경상업학교) 졸업기념사진첩 제9회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "江景公立商業學校",
        "publisher_ko": "강경공립상업학교",
        "library": "△",
        "school_id": 52974,
        "primaryname": "江景公立商業學校",
        "primaryname_ko": "강경공립상업학교"
    },
    {
        "book_id": 10725,
        "book_title": "(江景商業學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(강경상업학교) 졸업기념사진첩 제9회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "江景公立商業學校",
        "publisher_ko": "강경공립상업학교",
        "library": "△",
        "school_id": 52836,
        "primaryname": "江景商業學校",
        "primaryname_ko": "강경상업학교"
    },
    {
        "book_id": 10726,
        "book_title": "(康津農業學校) 卒業記念 第3回",
        "book_title_ko": "(강진농업학교) 졸업기념 제3회",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "康津公立農業學校",
        "publisher_ko": "강진공립농업학교",
        "library": "○",
        "school_id": 52975,
        "primaryname": "康津公立農業學校",
        "primaryname_ko": "강진공립농업학교"
    },
    {
        "book_id": 10726,
        "book_title": "(康津農業學校) 卒業記念 第3回",
        "book_title_ko": "(강진농업학교) 졸업기념 제3회",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "康津公立農業學校",
        "publisher_ko": "강진공립농업학교",
        "library": "○",
        "school_id": 52862,
        "primaryname": "康津農業學校",
        "primaryname_ko": "강진농업학교"
    },
    {
        "book_id": 10727,
        "book_title": "(康津農業學校) 추억 第4回 卒業記念",
        "book_title_ko": "(강진농업학교) 추억 제4회 졸업기념",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "康津公立農業學校",
        "publisher_ko": "강진공립농업학교",
        "library": "△",
        "school_id": 52975,
        "primaryname": "康津公立農業學校",
        "primaryname_ko": "강진공립농업학교"
    },
    {
        "book_id": 10727,
        "book_title": "(康津農業學校) 추억 第4回 卒業記念",
        "book_title_ko": "(강진농업학교) 추억 제4회 졸업기념",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "康津公立農業學校",
        "publisher_ko": "강진공립농업학교",
        "library": "△",
        "school_id": 52862,
        "primaryname": "康津農業學校",
        "primaryname_ko": "강진농업학교"
    },
    {
        "book_id": 10728,
        "book_title": "(漢城商業學校) 卒業記念 寫眞帖 第4回",
        "book_title_ko": "(한성상업학교) 졸업기념 사진첩 제4회",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "漢城商業學校",
        "publisher_ko": "한성상업학교",
        "library": "△",
        "school_id": 52976,
        "primaryname": "漢城商業學校",
        "primaryname_ko": "한성상업학교"
    },
    {
        "book_id": 10728,
        "book_title": "(漢城商業學校) 卒業記念 寫眞帖 第4回",
        "book_title_ko": "(한성상업학교) 졸업기념 사진첩 제4회",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "漢城商業學校",
        "publisher_ko": "한성상업학교",
        "library": "△",
        "school_id": 52863,
        "primaryname": "漢城商業學校",
        "primaryname_ko": "한성상업학교"
    },
    {
        "book_id": 10729,
        "book_title": "(京城電氣學校) 卒業記念 ",
        "book_title_ko": "(경성전기학교) 졸업기념 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城電氣學校 土木部",
        "publisher_ko": "경성전기학교 토목부",
        "library": "△",
        "school_id": 52977,
        "primaryname": "京城電氣學校 土木部",
        "primaryname_ko": "경성전기학교 토목부"
    },
    {
        "book_id": 10729,
        "book_title": "(京城電氣學校) 卒業記念 ",
        "book_title_ko": "(경성전기학교) 졸업기념 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城電氣學校 土木部",
        "publisher_ko": "경성전기학교 토목부",
        "library": "△",
        "school_id": 52864,
        "primaryname": "京城電氣學校",
        "primaryname_ko": "경성전기학교"
    },
    {
        "book_id": 10730,
        "book_title": "(京城電氣學校) 추억 第11回 卒業記念",
        "book_title_ko": "(경성전기학교) 추억 제11회 졸업기념",
        "publish_date": "1943.03.00",
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城電氣學校 土木部",
        "publisher_ko": "경성전기학교 토목부",
        "library": "△",
        "school_id": 52977,
        "primaryname": "京城電氣學校 土木部",
        "primaryname_ko": "경성전기학교 토목부"
    },
    {
        "book_id": 10730,
        "book_title": "(京城電氣學校) 추억 第11回 卒業記念",
        "book_title_ko": "(경성전기학교) 추억 제11회 졸업기념",
        "publish_date": "1943.03.00",
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城電氣學校 土木部",
        "publisher_ko": "경성전기학교 토목부",
        "library": "△",
        "school_id": 52864,
        "primaryname": "京城電氣學校",
        "primaryname_ko": "경성전기학교"
    },
    {
        "book_id": 10731,
        "book_title": "(大丘農林學校) 卒業記念 第25回",
        "book_title_ko": "(대구농림학교) 졸업기념 제25회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大丘公立農林學校",
        "publisher_ko": "대구공립농림학교",
        "library": "△",
        "school_id": 52968,
        "primaryname": "大丘公立農林學校",
        "primaryname_ko": "대구공립농림학교"
    },
    {
        "book_id": 10731,
        "book_title": "(大丘農林學校) 卒業記念 第25回",
        "book_title_ko": "(대구농림학교) 졸업기념 제25회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大丘公立農林學校",
        "publisher_ko": "대구공립농림학교",
        "library": "△",
        "school_id": 52855,
        "primaryname": "大丘農林學校",
        "primaryname_ko": "대구농림학교"
    },
    {
        "book_id": 10732,
        "book_title": "(大田工科學院) 卒業記念 測量科 第10回",
        "book_title_ko": "(대전공과학원) 졸업기념 측량과 제10회",
        "publish_date": "1938.09.00",
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 0,
        "publisher": "大田工科學院",
        "publisher_ko": "대전공과학원",
        "library": "△",
        "school_id": 52978,
        "primaryname": "大田工科學院",
        "primaryname_ko": "대전공과학원"
    },
    {
        "book_id": 10732,
        "book_title": "(大田工科學院) 卒業記念 測量科 第10回",
        "book_title_ko": "(대전공과학원) 졸업기념 측량과 제10회",
        "publish_date": "1938.09.00",
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 0,
        "publisher": "大田工科學院",
        "publisher_ko": "대전공과학원",
        "library": "△",
        "school_id": 52865,
        "primaryname": "大田工科學院",
        "primaryname_ko": "대전공과학원"
    },
    {
        "book_id": 10733,
        "book_title": "(大田職業學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(대전직업학교) 졸업기념사진첩 제2회",
        "publish_date": "1943.03.00",
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "大田公立職業學校",
        "publisher_ko": "대전공립직업학교",
        "library": "△",
        "school_id": 52979,
        "primaryname": "大田公立職業學校",
        "primaryname_ko": "대전공립직업학교"
    },
    {
        "book_id": 10733,
        "book_title": "(大田職業學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(대전직업학교) 졸업기념사진첩 제2회",
        "publish_date": "1943.03.00",
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "大田公立職業學校",
        "publisher_ko": "대전공립직업학교",
        "library": "△",
        "school_id": 52866,
        "primaryname": "大田職業學校",
        "primaryname_ko": "대전직업학교"
    },
    {
        "book_id": 10734,
        "book_title": "(德成女子實業學校) 卒業記念 第8回",
        "book_title_ko": "(덕성여자실업학교) 졸업기념 제8회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "德成女子實業學校",
        "publisher_ko": "덕성녀자실업학교",
        "library": "△",
        "school_id": 47194,
        "primaryname": "德成女子實業學校",
        "primaryname_ko": null
    },
    {
        "book_id": 10734,
        "book_title": "(德成女子實業學校) 卒業記念 第8回",
        "book_title_ko": "(덕성여자실업학교) 졸업기념 제8회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "德成女子實業學校",
        "publisher_ko": "덕성녀자실업학교",
        "library": "△",
        "school_id": 52867,
        "primaryname": "德成女子實業學校",
        "primaryname_ko": "덕성여자실업학교"
    },
    {
        "book_id": 10735,
        "book_title": "(東亞商業學校) 卒業記念 第13回",
        "book_title_ko": "(동아상업학교) 졸업기념 제13회",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "野方學園 東亞商業學校",
        "publisher_ko": "야방학원 동아상업학교",
        "library": "△",
        "school_id": 52980,
        "primaryname": "野方學園 東亞商業學校",
        "primaryname_ko": "야방학원 동아상업학교"
    },
    {
        "book_id": 10735,
        "book_title": "(東亞商業學校) 卒業記念 第13回",
        "book_title_ko": "(동아상업학교) 졸업기념 제13회",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "野方學園 東亞商業學校",
        "publisher_ko": "야방학원 동아상업학교",
        "library": "△",
        "school_id": 52868,
        "primaryname": "東亞商業學校",
        "primaryname_ko": "동아상업학교"
    },
    {
        "book_id": 10736,
        "book_title": "(馬山商業學校) 卒業記念寫眞帖 第17回",
        "book_title_ko": "(마산상업학교) 졸업기념사진첩 제17회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "馬山公立商業學校",
        "publisher_ko": "마산공립상업학교",
        "library": "△",
        "school_id": 52981,
        "primaryname": "馬山公立商業學校",
        "primaryname_ko": "마산공립상업학교"
    },
    {
        "book_id": 10736,
        "book_title": "(馬山商業學校) 卒業記念寫眞帖 第17回",
        "book_title_ko": "(마산상업학교) 졸업기념사진첩 제17회",
        "publish_date": "1941.03.00",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "馬山公立商業學校",
        "publisher_ko": "마산공립상업학교",
        "library": "△",
        "school_id": 52869,
        "primaryname": "馬山商業學校",
        "primaryname_ko": "마산상업학교"
    },
    {
        "book_id": 10737,
        "book_title": "(木浦商業學校) 卒業記念寫眞帖 第22回(1943年 12月)",
        "book_title_ko": "(목포상업학교) 졸업기념사진첩 제22회(1943년 12월)",
        "publish_date": "1943.12.00",
        "publish_year": 1943,
        "publish_month": 12,
        "publish_day": 0,
        "publisher": "木浦公立商業學校",
        "publisher_ko": "목포공립상업학교",
        "library": "△",
        "school_id": 52965,
        "primaryname": "木浦公立商業學校",
        "primaryname_ko": "목포공립상업학교"
    },
    {
        "book_id": 10737,
        "book_title": "(木浦商業學校) 卒業記念寫眞帖 第22回(1943年 12月)",
        "book_title_ko": "(목포상업학교) 졸업기념사진첩 제22회(1943년 12월)",
        "publish_date": "1943.12.00",
        "publish_year": 1943,
        "publish_month": 12,
        "publish_day": 0,
        "publisher": "木浦公立商業學校",
        "publisher_ko": "목포공립상업학교",
        "library": "△",
        "school_id": 52843,
        "primaryname": "木浦商業學校",
        "primaryname_ko": "목포상업학교"
    },
    {
        "book_id": 10738,
        "book_title": "(木浦商業專修學校) 졸업앨범 ",
        "book_title_ko": "(목포상업전수학교) 졸업앨범 ",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "木浦商業專修學校",
        "publisher_ko": "목포상업전수학교",
        "library": "△",
        "school_id": 27580,
        "primaryname": "木浦商業專修學校",
        "primaryname_ko": "목포상업전수학교"
    },
    {
        "book_id": 10738,
        "book_title": "(木浦商業專修學校) 졸업앨범 ",
        "book_title_ko": "(목포상업전수학교) 졸업앨범 ",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "木浦商業專修學校",
        "publisher_ko": "목포상업전수학교",
        "library": "△",
        "school_id": 52870,
        "primaryname": "木浦商業專修學校",
        "primaryname_ko": "목포상업전수학교"
    },
    {
        "book_id": 10739,
        "book_title": "(密陽農蠶學校) 卒業生記念寫眞帖 第8回",
        "book_title_ko": "(밀양농잠학교) 졸업생기념사진첩 제8회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "密陽農蠶學校",
        "publisher_ko": "밀양농잠학교",
        "library": "△",
        "school_id": 52982,
        "primaryname": "密陽農蠶學校",
        "primaryname_ko": "밀양농잠학교"
    },
    {
        "book_id": 10739,
        "book_title": "(密陽農蠶學校) 卒業生記念寫眞帖 第8回",
        "book_title_ko": "(밀양농잠학교) 졸업생기념사진첩 제8회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "密陽農蠶學校",
        "publisher_ko": "밀양농잠학교",
        "library": "△",
        "school_id": 52871,
        "primaryname": "密陽農蠶學校",
        "primaryname_ko": "밀양농잠학교"
    },
    {
        "book_id": 10740,
        "book_title": "(寶成農業實修學校) 卒業記念 第3回",
        "book_title_ko": "(보성농업실수학교) 졸업기념 제3회",
        "publish_date": "1939.02.00",
        "publish_year": 1939,
        "publish_month": 2,
        "publish_day": 0,
        "publisher": "寶成公立農業實修學校",
        "publisher_ko": "보성공립농업실수학교",
        "library": "△",
        "school_id": 52983,
        "primaryname": "寶成公立農業實修學校",
        "primaryname_ko": "보성공립농업실수학교"
    },
    {
        "book_id": 10740,
        "book_title": "(寶成農業實修學校) 卒業記念 第3回",
        "book_title_ko": "(보성농업실수학교) 졸업기념 제3회",
        "publish_date": "1939.02.00",
        "publish_year": 1939,
        "publish_month": 2,
        "publish_day": 0,
        "publisher": "寶成公立農業實修學校",
        "publisher_ko": "보성공립농업실수학교",
        "library": "△",
        "school_id": 52872,
        "primaryname": "寶成農業實修學校",
        "primaryname_ko": "보성농업실수학교"
    },
    {
        "book_id": 10741,
        "book_title": "(輔仁商業學校) 卒業記念 第3回",
        "book_title_ko": "(보인상업학교) 졸업기념 제3회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "輔仁商業學校",
        "publisher_ko": "보인상업학교",
        "library": "△",
        "school_id": 52984,
        "primaryname": "輔仁商業學校",
        "primaryname_ko": "보인상업학교"
    },
    {
        "book_id": 10741,
        "book_title": "(輔仁商業學校) 卒業記念 第3回",
        "book_title_ko": "(보인상업학교) 졸업기념 제3회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "輔仁商業學校",
        "publisher_ko": "보인상업학교",
        "library": "△",
        "school_id": 52873,
        "primaryname": "輔仁商業學校",
        "primaryname_ko": "보인상업학교"
    },
    {
        "book_id": 10742,
        "book_title": "(大田測量學校) 卒業記念 第5回",
        "book_title_ko": "(대전측량학교) 졸업기념 제5회",
        "publish_date": "1936.04.00",
        "publish_year": 1936,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "官認大田測量學校",
        "publisher_ko": "관인대전측량학교",
        "library": "△",
        "school_id": 52985,
        "primaryname": "官認大田測量學校",
        "primaryname_ko": "관인대전측량학교"
    },
    {
        "book_id": 10742,
        "book_title": "(大田測量學校) 卒業記念 第5回",
        "book_title_ko": "(대전측량학교) 졸업기념 제5회",
        "publish_date": "1936.04.00",
        "publish_year": 1936,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "官認大田測量學校",
        "publisher_ko": "관인대전측량학교",
        "library": "△",
        "school_id": 52874,
        "primaryname": "大田測量學校",
        "primaryname_ko": "대전측량학교"
    },
    {
        "book_id": 10743,
        "book_title": "(順天農業學校) 卒業寫眞帖 第1回",
        "book_title_ko": "(순천농업학교) 졸업사진첩 제1회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "順天公立農業學校",
        "publisher_ko": "순천공립농업학교",
        "library": "△",
        "school_id": 52986,
        "primaryname": "順天公立農業學校",
        "primaryname_ko": "순천공립농업학교"
    },
    {
        "book_id": 10743,
        "book_title": "(順天農業學校) 卒業寫眞帖 第1回",
        "book_title_ko": "(순천농업학교) 졸업사진첩 제1회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "順天公立農業學校",
        "publisher_ko": "순천공립농업학교",
        "library": "△",
        "school_id": 52875,
        "primaryname": "順天農業學校",
        "primaryname_ko": "순천농업학교"
    },
    {
        "book_id": 10744,
        "book_title": "(安東農林學校) 졸업앨범 第6回",
        "book_title_ko": "(안동농림학교) 졸업앨범 제6회",
        "publish_date": "1942.12.00",
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 0,
        "publisher": "安東公立農林學校",
        "publisher_ko": "안동공립농림학교",
        "library": "△",
        "school_id": 52987,
        "primaryname": "安東公立農林學校",
        "primaryname_ko": "안동공립농림학교"
    },
    {
        "book_id": 10744,
        "book_title": "(安東農林學校) 졸업앨범 第6回",
        "book_title_ko": "(안동농림학교) 졸업앨범 제6회",
        "publish_date": "1942.12.00",
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 0,
        "publisher": "安東公立農林學校",
        "publisher_ko": "안동공립농림학교",
        "library": "△",
        "school_id": 52876,
        "primaryname": "安東農林學校",
        "primaryname_ko": "안동농림학교"
    },
    {
        "book_id": 10745,
        "book_title": "(裡里農林學校) 卒業記念 (農業科 第13回 林業科 第11回 獸畜科 第4回)",
        "book_title_ko": "(이리농림학교) 졸업기념 (농업과 제13회 임업과 제11회 수축과 제4회)",
        "publish_date": "1937.03.16",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 16,
        "publisher": "裡里公立農林學校",
        "publisher_ko": "이리공립농림학교",
        "library": "",
        "school_id": 52988,
        "primaryname": "裡里公立農林學校",
        "primaryname_ko": "이리공립농림학교"
    },
    {
        "book_id": 10745,
        "book_title": "(裡里農林學校) 卒業記念 (農業科 第13回 林業科 第11回 獸畜科 第4回)",
        "book_title_ko": "(이리농림학교) 졸업기념 (농업과 제13회 임업과 제11회 수축과 제4회)",
        "publish_date": "1937.03.16",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 16,
        "publisher": "裡里公立農林學校",
        "publisher_ko": "이리공립농림학교",
        "library": "",
        "school_id": 52848,
        "primaryname": "裡里農林學校",
        "primaryname_ko": "이리농림학교"
    },
    {
        "book_id": 10746,
        "book_title": "(全州農業學校) 紀念寫眞帖 20周年",
        "book_title_ko": "(전주농업학교) 기념사진첩 20주년",
        "publish_date": "1930.04.00",
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "全州公立農業學校",
        "publisher_ko": "전주공립농업학교",
        "library": "○",
        "school_id": 52989,
        "primaryname": "全州公立農業學校",
        "primaryname_ko": "전주공립농업학교"
    },
    {
        "book_id": 10746,
        "book_title": "(全州農業學校) 紀念寫眞帖 20周年",
        "book_title_ko": "(전주농업학교) 기념사진첩 20주년",
        "publish_date": "1930.04.00",
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "全州公立農業學校",
        "publisher_ko": "전주공립농업학교",
        "library": "○",
        "school_id": 52877,
        "primaryname": "全州農業學校",
        "primaryname_ko": "전주농업학교"
    },
    {
        "book_id": 10747,
        "book_title": "(全州農業學校) 思ひ出 第22回 卒",
        "book_title_ko": "(전주농업학교) 사ひ출 제22회 졸",
        "publish_date": "1936.02.20",
        "publish_year": 1936,
        "publish_month": 2,
        "publish_day": 20,
        "publisher": "全州公立農業學校",
        "publisher_ko": "전주공립농업학교",
        "library": "국립중앙도서관",
        "school_id": 52989,
        "primaryname": "全州公立農業學校",
        "primaryname_ko": "전주공립농업학교"
    },
    {
        "book_id": 10747,
        "book_title": "(全州農業學校) 思ひ出 第22回 卒",
        "book_title_ko": "(전주농업학교) 사ひ출 제22회 졸",
        "publish_date": "1936.02.20",
        "publish_year": 1936,
        "publish_month": 2,
        "publish_day": 20,
        "publisher": "全州公立農業學校",
        "publisher_ko": "전주공립농업학교",
        "library": "국립중앙도서관",
        "school_id": 52877,
        "primaryname": "全州農業學校",
        "primaryname_ko": "전주농업학교"
    },
    {
        "book_id": 10748,
        "book_title": "(鎭南浦商工學校) 卒業記念寫眞帖 機械科 第22回(昭和15年 3月)",
        "book_title_ko": "(진남포상공학교) 졸업기념사진첩 기계과 제22회(소화15년 3월)",
        "publish_date": "1940.03.00",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "鎭南浦公立商工學校",
        "publisher_ko": "진남포공립상공학교",
        "library": "△",
        "school_id": 52990,
        "primaryname": "鎭南浦公立商工學校",
        "primaryname_ko": "진남포공립상공학교"
    },
    {
        "book_id": 10748,
        "book_title": "(鎭南浦商工學校) 卒業記念寫眞帖 機械科 第22回(昭和15年 3月)",
        "book_title_ko": "(진남포상공학교) 졸업기념사진첩 기계과 제22회(소화15년 3월)",
        "publish_date": "1940.03.00",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "鎭南浦公立商工學校",
        "publisher_ko": "진남포공립상공학교",
        "library": "△",
        "school_id": 52878,
        "primaryname": "鎭南浦商工學校",
        "primaryname_ko": "진남포상공학교"
    },
    {
        "book_id": 10749,
        "book_title": "(晋州農業學校) 晋農園藝部 졸업앨범 ",
        "book_title_ko": "(진주농업학교) 진농원예부 졸업앨범 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "晋州公立農業學校",
        "publisher_ko": "진주공립농업학교",
        "library": "△",
        "school_id": 37824,
        "primaryname": "晋州公立農業學校",
        "primaryname_ko": "진주공립농업학교"
    },
    {
        "book_id": 10749,
        "book_title": "(晋州農業學校) 晋農園藝部 졸업앨범 ",
        "book_title_ko": "(진주농업학교) 진농원예부 졸업앨범 ",
        "publish_date": "1942.00.00",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "晋州公立農業學校",
        "publisher_ko": "진주공립농업학교",
        "library": "△",
        "school_id": 52859,
        "primaryname": "晋州農業學校",
        "primaryname_ko": "진주농업학교"
    },
    {
        "book_id": 10791,
        "book_title": "(京城女子高等普通學校) 卒業記念 第16回",
        "book_title_ko": "(경성여자고등보통학교) 졸업기념 제16회",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子高等普通學校",
        "publisher_ko": "경성여자고등보통학교",
        "library": "△",
        "school_id": 18796,
        "primaryname": "京城女子高等普通學校",
        "primaryname_ko": "경성여자고등보통학교"
    },
    {
        "book_id": 10791,
        "book_title": "(京城女子高等普通學校) 卒業記念 第16回",
        "book_title_ko": "(경성여자고등보통학교) 졸업기념 제16회",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子高等普通學校",
        "publisher_ko": "경성여자고등보통학교",
        "library": "△",
        "school_id": 52893,
        "primaryname": "京城女子高等普通學校",
        "primaryname_ko": "경성여자고등보통학교"
    },
    {
        "book_id": 10792,
        "book_title": "(京城女子高等普通學校) 卒業記念 第9回",
        "book_title_ko": "(경성여자고등보통학교) 졸업기념 제9회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子高等普通學校",
        "publisher_ko": "경성여자고등보통학교",
        "library": "△",
        "school_id": 18796,
        "primaryname": "京城女子高等普通學校",
        "primaryname_ko": "경성여자고등보통학교"
    },
    {
        "book_id": 10792,
        "book_title": "(京城女子高等普通學校) 卒業記念 第9回",
        "book_title_ko": "(경성여자고등보통학교) 졸업기념 제9회",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城女子高等普通學校",
        "publisher_ko": "경성여자고등보통학교",
        "library": "△",
        "school_id": 52893,
        "primaryname": "京城女子高等普通學校",
        "primaryname_ko": "경성여자고등보통학교"
    },
    {
        "book_id": 10793,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제2회",
        "publish_date": "1932.03.00",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52994,
        "primaryname": "光州公立女子高等普通學校",
        "primaryname_ko": "광주공립여자고등보통학교"
    },
    {
        "book_id": 10793,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第2回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제2회",
        "publish_date": "1932.03.00",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52894,
        "primaryname": "光州女子高等普通學校",
        "primaryname_ko": "광주여자고등보통학교"
    },
    {
        "book_id": 10794,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第3回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제3회",
        "publish_date": "1933.03.00",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52994,
        "primaryname": "光州公立女子高等普通學校",
        "primaryname_ko": "광주공립여자고등보통학교"
    },
    {
        "book_id": 10794,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第3回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제3회",
        "publish_date": "1933.03.00",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52894,
        "primaryname": "光州女子高等普通學校",
        "primaryname_ko": "광주여자고등보통학교"
    },
    {
        "book_id": 10795,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第4回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제4회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52994,
        "primaryname": "光州公立女子高等普通學校",
        "primaryname_ko": "광주공립여자고등보통학교"
    },
    {
        "book_id": 10795,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第4回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제4회",
        "publish_date": "1934.03.00",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52894,
        "primaryname": "光州女子高等普通學校",
        "primaryname_ko": "광주여자고등보통학교"
    },
    {
        "book_id": 10796,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第5回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제5회",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52994,
        "primaryname": "光州公立女子高等普通學校",
        "primaryname_ko": "광주공립여자고등보통학교"
    },
    {
        "book_id": 10796,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第5回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제5회",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52894,
        "primaryname": "光州女子高等普通學校",
        "primaryname_ko": "광주여자고등보통학교"
    },
    {
        "book_id": 10797,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第8回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제8회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52994,
        "primaryname": "光州公立女子高等普通學校",
        "primaryname_ko": "광주공립여자고등보통학교"
    },
    {
        "book_id": 10797,
        "book_title": "(光州女子高等普通學校) 卒業記念寫眞帖 第8回",
        "book_title_ko": "(광주여자고등보통학교) 졸업기념사진첩 제8회",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "光州公立女子高等普通學校",
        "publisher_ko": "광주공립여자고등보통학교",
        "library": "",
        "school_id": 52894,
        "primaryname": "光州女子高等普通學校",
        "primaryname_ko": "광주여자고등보통학교"
    },
    {
        "book_id": 10798,
        "book_title": "(同德女子高等普通學校) 卒業記念 第23回",
        "book_title_ko": "(동덕여자고등보통학교) 졸업기념 제23회",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子高等普通學校",
        "publisher_ko": "동덕여자고등보통학교",
        "library": "△",
        "school_id": 52883,
        "primaryname": "同德女子高等普通學校",
        "primaryname_ko": "동덕여자고등보통학교"
    },
    {
        "book_id": 10799,
        "book_title": "(培花女子高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(배화여자고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "培花女子高等普通學校",
        "publisher_ko": "배화녀자고등보통학교",
        "library": "△",
        "school_id": 52996,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화녀자고등보통학교"
    },
    {
        "book_id": 10799,
        "book_title": "(培花女子高等普通學校) 卒業記念寫眞帖 第9回",
        "book_title_ko": "(배화여자고등보통학교) 졸업기념사진첩 제9회",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "培花女子高等普通學校",
        "publisher_ko": "배화녀자고등보통학교",
        "library": "△",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10800,
        "book_title": "(釜山女子高等普通學校) 卒業記念 第3回",
        "book_title_ko": "(부산여자고등보통학교) 졸업기념 제3회",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山公立女子高等普通學校",
        "publisher_ko": "부산공립녀자고등보통학교",
        "library": "△",
        "school_id": 52997,
        "primaryname": "釜山公立女子高等普通學校",
        "primaryname_ko": "부산공립녀자고등보통학교"
    },
    {
        "book_id": 10800,
        "book_title": "(釜山女子高等普通學校) 卒業記念 第3回",
        "book_title_ko": "(부산여자고등보통학교) 졸업기념 제3회",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山公立女子高等普通學校",
        "publisher_ko": "부산공립녀자고등보통학교",
        "library": "△",
        "school_id": 52885,
        "primaryname": "釜山女子高等普通學校",
        "primaryname_ko": "부산여자고등보통학교"
    },
    {
        "book_id": 10801,
        "book_title": "(淑明女子高等普通學校) 卒業記念 第27回",
        "book_title_ko": "(숙명여자고등보통학교) 졸업기념 제27회",
        "publish_date": "1936.03.00",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "淑明女子高等普通學校",
        "publisher_ko": "숙명녀자고등보통학교",
        "library": "△",
        "school_id": 19036,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명녀자고등보통학교"
    },
    {
        "book_id": 10801,
        "book_title": "(淑明女子高等普通學校) 卒業記念 第27回",
        "book_title_ko": "(숙명여자고등보통학교) 졸업기념 제27회",
        "publish_date": "1936.03.00",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "淑明女子高等普通學校",
        "publisher_ko": "숙명녀자고등보통학교",
        "library": "△",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10802,
        "book_title": "(梨花女子高等普通學校) 卒業記念 第18回",
        "book_title_ko": "(이화여자고등보통학교) 졸업기념 제18회",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子高等普通學校",
        "publisher_ko": "이화녀자고등보통학교",
        "library": "△",
        "school_id": 52998,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화녀자고등보통학교"
    },
    {
        "book_id": 10802,
        "book_title": "(梨花女子高等普通學校) 卒業記念 第18回",
        "book_title_ko": "(이화여자고등보통학교) 졸업기념 제18회",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子高等普通學校",
        "publisher_ko": "이화녀자고등보통학교",
        "library": "△",
        "school_id": 52887,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화여자고등보통학교"
    },
    {
        "book_id": 10803,
        "book_title": "(梨花女子高等普通學校) 卒業記念 第34回",
        "book_title_ko": "(이화여자고등보통학교) 졸업기념 제34회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子高等普通學校",
        "publisher_ko": "이화녀자고등보통학교",
        "library": "",
        "school_id": 52998,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화녀자고등보통학교"
    },
    {
        "book_id": 10803,
        "book_title": "(梨花女子高等普通學校) 卒業記念 第34回",
        "book_title_ko": "(이화여자고등보통학교) 졸업기념 제34회",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女子高等普通學校",
        "publisher_ko": "이화녀자고등보통학교",
        "library": "",
        "school_id": 52887,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화여자고등보통학교"
    },
    {
        "book_id": 10804,
        "book_title": "(全州女子高等普通學校) 思ひ出 第9回 卒業",
        "book_title_ko": "(전주여자고등보통학교) 사ひ출 제9회 졸업",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "全州公立女子高等普通學校",
        "publisher_ko": "전주공립여자고등보통학교",
        "library": "△",
        "school_id": 52999,
        "primaryname": "全州公立女子高等普通學校",
        "primaryname_ko": "전주공립여자고등보통학교"
    },
    {
        "book_id": 10804,
        "book_title": "(全州女子高等普通學校) 思ひ出 第9回 卒業",
        "book_title_ko": "(전주여자고등보통학교) 사ひ출 제9회 졸업",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "全州公立女子高等普通學校",
        "publisher_ko": "전주공립여자고등보통학교",
        "library": "△",
        "school_id": 52892,
        "primaryname": "全州女子高等普通學校",
        "primaryname_ko": "전주여자고등보통학교"
    },
    {
        "book_id": 10805,
        "book_title": "(全州女子高等普通學校) 卒業記念 第4回",
        "book_title_ko": "(전주여자고등보통학교) 졸업기념 제4회",
        "publish_date": "1933.03.00",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "全州公立女子高等普通學校",
        "publisher_ko": "전주공립여자고등보통학교",
        "library": "△",
        "school_id": 52999,
        "primaryname": "全州公立女子高等普通學校",
        "primaryname_ko": "전주공립여자고등보통학교"
    },
    {
        "book_id": 10805,
        "book_title": "(全州女子高等普通學校) 卒業記念 第4回",
        "book_title_ko": "(전주여자고등보통학교) 졸업기념 제4회",
        "publish_date": "1933.03.00",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "全州公立女子高等普通學校",
        "publisher_ko": "전주공립여자고등보통학교",
        "library": "△",
        "school_id": 52892,
        "primaryname": "全州女子高等普通學校",
        "primaryname_ko": "전주여자고등보통학교"
    },
    {
        "book_id": 10900,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1940.00.00.",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10900,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1940.00.00.",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10901,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1941.00.00.",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10901,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1941.00.00.",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10902,
        "book_title": "(惠化專門學校) 勿忘草 (皇紀)2602",
        "book_title_ko": "(혜화전문학교) 물망초 (황기)2602",
        "publish_date": "1942.00.00.",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "△",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10902,
        "book_title": "(惠化專門學校) 勿忘草 (皇紀)2602",
        "book_title_ko": "(혜화전문학교) 물망초 (황기)2602",
        "publish_date": "1942.00.00.",
        "publish_year": 1942,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "△",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10903,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1943.00.00.",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10903,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1943.00.00.",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10904,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1944.00.00.",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10904,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1944.00.00.",
        "publish_year": 1944,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10905,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1945.00.00.",
        "publish_year": 1945,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 27161,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10905,
        "book_title": "(惠化專門學校) (졸업앨범) ",
        "book_title_ko": "(혜화전문학교) (졸업앨범) ",
        "publish_date": "1945.00.00.",
        "publish_year": 1945,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "惠化專門學校",
        "publisher_ko": "혜화전문학교",
        "library": "",
        "school_id": 52914,
        "primaryname": "惠化專門學校",
        "primaryname_ko": "혜화전문학교"
    },
    {
        "book_id": 10969,
        "book_title": "(大成中學校) (졸업앨범) 第4回",
        "book_title_ko": "(대성중학교) (졸업앨범) 제4회",
        "publish_date": "1930.03.00",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "大成中學校",
        "publisher_ko": "대성중학교",
        "library": "",
        "school_id": 53009,
        "primaryname": "大成中學校",
        "primaryname_ko": "대성중학교"
    },
    {
        "book_id": 10969,
        "book_title": "(大成中學校) (졸업앨범) 第4回",
        "book_title_ko": "(대성중학교) (졸업앨범) 제4회",
        "publish_date": "1930.03.00",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "大成中學校",
        "publisher_ko": "대성중학교",
        "library": "",
        "school_id": 52934,
        "primaryname": "大成中學校",
        "primaryname_ko": "대성중학교"
    },
    {
        "book_id": 10970,
        "book_title": "(培材中學校) 卒業記念 ",
        "book_title_ko": "(배재중학교) 졸업기념 ",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材中學校",
        "publisher_ko": "배재중학교",
        "library": "△",
        "school_id": 27278,
        "primaryname": "培材中學校",
        "primaryname_ko": "배재중학교"
    },
    {
        "book_id": 10970,
        "book_title": "(培材中學校) 卒業記念 ",
        "book_title_ko": "(배재중학교) 졸업기념 ",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材中學校",
        "publisher_ko": "배재중학교",
        "library": "△",
        "school_id": 52935,
        "primaryname": "培材中學校",
        "primaryname_ko": "배재중학교"
    },
    {
        "book_id": 10971,
        "book_title": "(中央中學校) 卒業記念 31回",
        "book_title_ko": "(중앙중학교) 졸업기념 31회",
        "publish_date": "1940.03.00",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "△",
        "school_id": 52936,
        "primaryname": "中央中學校",
        "primaryname_ko": "중앙중학교"
    },
    {
        "book_id": 10972,
        "book_title": "(徽文中學校) 卒業記念 第35回 (1943)",
        "book_title_ko": "(휘문중학교) 졸업기념 제35회 (1943)",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文中學校",
        "publisher_ko": "휘문중학교",
        "library": "△",
        "school_id": 27279,
        "primaryname": "徽文中學校",
        "primaryname_ko": "휘문중학교"
    },
    {
        "book_id": 10972,
        "book_title": "(徽文中學校) 卒業記念 第35回 (1943)",
        "book_title_ko": "(휘문중학교) 졸업기념 제35회 (1943)",
        "publish_date": "1943.00.00",
        "publish_year": 1943,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文中學校",
        "publisher_ko": "휘문중학교",
        "library": "△",
        "school_id": 52930,
        "primaryname": "徽文中學校",
        "primaryname_ko": "휘문중학교"
    }
]

export default AlbumData;